<template>
  <div>
    <div>
      <label class="ts-mb-0">{{ $t('productProfile.vendorList') }}</label>
      <a-select
        class="ts-w-full"
        mode="multiple"
        v-model="model.vendor_list"
        :options="vendorList"
        :filterOption="
          (input, option) =>
            option.componentOptions.children[0].text
              .toLowerCase()
              .indexOf(input.toLowerCase()) >= 0
        "
        :maxTagCount="4"
      ></a-select>
    </div>
  </div>
</template>

<script>
import { Errors } from 'form-backend-validation'
export default {
  name: 'vendorList',
  props: ['value', 'validate', 'full'],
  data() {
    return {
      errors: new Errors(),
      model: {}
    }
  },
  created() {
    this.model = this.value
  },
  computed: {
    vendorList() {
      return this.$store.state.product.profile.vendors.map(el => ({
        value: el.vendor_id,
        label: el.vendor_name
      }))
    }
  },
  watch: {
    validate: function(error) {
      this.errors = new Errors(error.errors)
    }
  }
}
</script>
